const BTConstant = require('../utils/bt-constant')
const _ = require('lodash')
// const urlParser = require('url')

const getPrefix = (href) => {
    let newHref
    if(href.startsWith(BTConstant.DOC_PREFIX) || href.startsWith(BTConstant.ARTICLES_PREFIX) || href.startsWith(BTConstant.HELP_PREFIX)) {
        return href
    }
    if(href.startsWith(BTConstant.ART_PREFIX)) {                
        newHref = href.split(BTConstant.ART_PREFIX).join(`${BTConstant.ARTICLES_PREFIX}`)                
    } else if(href.startsWith(BTConstant.HE_PREFIX)) { 
        /**
         * Note: Enable below commented lines if we need to redirect traffic to
         * existing help.braintreepayments.com page
         */
        // let u = urlParser.parse(href)
        // u.protocol = 'https:'
        // u.host = 'help.braintreepayments.com'
        // u.pathname = '/'
        // newHref = urlParser.format(u)
                       
        newHref = href.split(BTConstant.HE_PREFIX).join(`${BTConstant.HELP_PREFIX}`)                
    } else {                
        newHref = `${BTConstant.DOC_PREFIX}${href}`
    }       
    return newHref
}

const getPageSection = (leftNav = {}, path) => {    
    const pathArray = path.split('/')
    path = path.endsWith('/') ? path.split('/').slice(0,-1).join('/') : path
    const parentPath = path.split('/').slice(0, -1).join('/')
    const sideNavSections = leftNav[pathArray[1]]         
    if (!sideNavSections) return        
    let pageSection
    _.forEach(sideNavSections, sideNavSection => {
        if(pageSection) return false        
        _.forEach(sideNavSection.menu,  menuItem => {
            if(pageSection) return false            
            if(menuItem.path && menuItem.path === parentPath) {                
                pageSection = menuItem.title                
                return false
            }
            if(menuItem.href && menuItem.href === parentPath) {                
                pageSection = menuItem.title                
                return false
            }
            if (menuItem.sub_menu) {                
                _.forEach(menuItem.sub_menu, subMenuItem => {                    
                    if(subMenuItem.path && subMenuItem.path === parentPath) {                
                        pageSection = subMenuItem.title                
                        return false
                    }
                    if(subMenuItem.href && subMenuItem.href === parentPath) {                        
                        pageSection = subMenuItem.title                
                        return false
                    }                                        
                });

            }
        });
    })  
    return pageSection;
  }

module.exports = {getPrefix, getPageSection}
